import React from "react";
import { Flex } from "antd";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";

const SuccessModal = ({
  isOpen,
  message = "Successfully",
  subMessage = "",
  btnLabel = "Ok",
  onSubmit = () => {},
}) => {
  const handleSubmit = () => {
    console.log(onSubmit);
    onSubmit();
  };
  return (
    <ModalComponent isOpen={isOpen} width={347}>
      <Flex vertical gap="1rem" align="center">
        <div className="icon-wrapper">
          <img src="/assets/images/done.svg" alt="" />
        </div>
        <div className="body-b1 text-center">{message}</div>
        {subMessage.length ? <div className="body-b4 text-center">{subMessage}</div> : <></>}
        <div>
          <ButtonComponent label={btnLabel} type="primary" onClick={handleSubmit} />
        </div>
      </Flex>
    </ModalComponent>
  );
};

export default SuccessModal;
